import { render, staticRenderFns } from "./PremiumBanner.vue?vue&type=template&id=fa05cf2c&scoped=true"
import script from "./PremiumBanner.vue?vue&type=script&lang=ts"
export * from "./PremiumBanner.vue?vue&type=script&lang=ts"
import style0 from "./PremiumBanner.vue?vue&type=style&index=0&id=fa05cf2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa05cf2c",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
